import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App2 from "./src2/App2";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <App2 />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
